import { render, staticRenderFns } from "./SortTab.vue?vue&type=template&id=b173e376&scoped=true&"
import script from "./SortTab.vue?vue&type=script&lang=ts&"
export * from "./SortTab.vue?vue&type=script&lang=ts&"
import style0 from "./SortTab.vue?vue&type=style&index=0&id=b173e376&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b173e376",
  null
  
)

export default component.exports